<template>
  <div>
    <menubar />
    <div class="container">
      <!--タイトルとボタンを並列に置きたい場合-->
      <div class="title-btn d-flex justify-content-between align-items-center">
        <div id="title" class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          <p class="h1">クライアント一覧</p>
        </div>
        <div>
          <Link class="btn btn-purple" :href="route('clients.create')">新規作成</Link>
        </div>
      </div>

      <div class="row row-cols-auto client-information">
        <div class="col">契約クライアント数 <span>{{ clientSummary.contract_number }}</span></div>
        <div class="col">利用クライアント数 <span>{{ clientSummary.use_contract_number }}</span></div>
        <div class="col">ID数 <span>{{ clientSummary.id_number }}</span></div>
        <div class="col">平均利用期間 <span>{{ clientSummary.usage_period }}</span></div>
        <!--
        <div class="col">AIモデル数 <span>{{ clientSummary.ai_model_number }}</span></div>
        -->
      </div>
        <!--
      <div class="row row-cols-auto client-information">
        <div class="col">請求金額 (税込) <span>{{ clientSummary.total_bill }}</span>円</div>
      </div>
        -->

      <div class="show-clients">
        <input type="text" class="with-icon" v-model="search_word" placeholder="クライアント名かメールアドレスを入力して検索">
        <table class="table component_table">
          <tbody>
            <tr class="table-font-size">
              <th class="align-middle text-center col-no">No</th>
              <th class="align-middle text-center col-name">クライアント名</th>
              <th class="align-middle text-center col-category" @click="sortBy('category')">カテゴリー
                <img class="sort-button" src="/img/25_order_nutral.svg" v-if="!sort_key.includes('category')"/>
                <img class="sort-button" src="/img/25_order_asc.svg" v-if="sort_key.includes('category') && sort_asc===1"/>
                <img class="sort-button" src="/img/25_order_desc.svg" v-if="sort_key.includes('category') && sort_asc===2"/>
              </th>
              <th class="align-middle text-center col-administrator">管理者</th>
              <th class="align-middle text-center col-email">メールアドレス</th>
              <th class="align-middle text-center col-status" @click="sortBy('status')">ステータス
                <img class="sort-button" src="/img/25_order_nutral.svg" v-if="!sort_key.includes('status')"/>
                <img class="sort-button" src="/img/25_order_asc.svg" v-if="sort_key.includes('status') && sort_asc===1"/>
                <img class="sort-button" src="/img/25_order_desc.svg" v-if="sort_key.includes('status') && sort_asc===2"/>
              </th>
              <th class="align-middle text-center col-plan" @click="sortBy('client_contract_plan.contract_plan.name')">プラン
                <img class="sort-button" src="/img/25_order_nutral.svg" v-if="!sort_key.includes('client_contract_plan.contract_plan.name')"/>
                <img class="sort-button" src="/img/25_order_asc.svg" v-if="sort_key.includes('client_contract_plan.contract_plan.name') && sort_asc===1"/>
                <img class="sort-button" src="/img/25_order_desc.svg" v-if="sort_key.includes('client_contract_plan.contract_plan.name') && sort_asc===2"/>
              </th>
              <th class="align-middle text-center col-idNum" @click="sortBy('user_length')">ID数
                <img class="sort-button" src="/img/25_order_nutral.svg" v-if="!sort_key.includes('user_length')"/>
                <img class="sort-button" src="/img/25_order_asc.svg" v-if="sort_key.includes('user_length') && sort_asc===1"/>
                <img class="sort-button" src="/img/25_order_desc.svg" v-if="sort_key.includes('user_length') && sort_asc===2"/>
              </th>
              <th class="align-middle text-center col-utilizationPeriod" @click="sortBy('segment')">利用期間
                <img class="sort-button" src="/img/25_order_nutral.svg" v-if="!sort_key.includes('segment')"/>
                <img class="sort-button" src="/img/25_order_asc.svg" v-if="sort_key.includes('segment') && sort_asc===1"/>
                <img class="sort-button" src="/img/25_order_desc.svg" v-if="sort_key.includes('segment') && sort_asc===2"/>
              </th>
              <!--
              <th class="align-middle text-center col-bill" @click="sortBy('bill')">請求額
                <img class="sort-button" src="/img/25_order_nutral.svg" v-if="!sort_key.includes('bill')"/>
                <img class="sort-button" src="/img/25_order_asc.svg" v-if="sort_key.includes('bill') && sort_asc===1"/>
                <img class="sort-button" src="/img/25_order_desc.svg" v-if="sort_key.includes('bill') && sort_asc===2"/>
              </th>
              <th class="align-middle text-center col-addContract" @click="sortBy('additional_options')">追加契約
                <img class="sort-button" src="/img/25_order_nutral.svg" v-if="!sort_key.includes('additional_options')"/>
                <img class="sort-button" src="/img/25_order_asc.svg" v-if="sort_key.includes('additional_options') && sort_asc===1"/>
                <img class="sort-button" src="/img/25_order_desc.svg" v-if="sort_key.includes('additional_options') && sort_asc===2"/>
              </th>
              -->
              <th class="align-middle text-center col-supplyData" @click="sortBy('is_allowed_training_data_provision')">データ提供
                <img class="sort-button" src="/img/25_order_nutral.svg" v-if="!sort_key.includes('is_allowed_training_data_provision')"/>
                <img class="sort-button" src="/img/25_order_asc.svg" v-if="sort_key.includes('is_allowed_training_data_provision') && sort_asc===1"/>
                <img class="sort-button" src="/img/25_order_desc.svg" v-if="sort_key.includes('is_allowed_training_data_provision') && sort_asc===2"/>
              </th>
              <th class="align-middle text-center col-supplyData">削除</th>
            </tr>
            <tr v-for="client in filteredUsers" :key="client.id">
              <td class="align-middle text-center" v-text="client.id"></td>
              <td class="align-middle text-center">
                <Link :href="route('clients.show', client.id)">{{client.name}}</Link>
              </td>
              <td class="align-middle text-center" v-text="client.category" />
              <td class="align-middle text-center" v-text="client.contractor_name" />
              <td class="align-middle text-center" v-text="client.contractor_email" />
              <td class="align-middle text-center" v-text="client.status == 0 ? '利用中' : (client.status == -1 ? '利用前' : '停止') " />
              <td class="align-middle text-center" v-text="client.client_contract_plan.contract_plan.name"></td>
              <td class="align-middle text-center" v-text="client.user_length" />
              <td class="align-middle text-center" v-text="client.segment" />
              <!--
              <td class="align-middle text-center" v-text="client.bill"></td>
              <td class="align-middle text-center" v-text="client.additional_options.length >= 1 ? 'あり' : 'なし'"></td>
              -->
              <td class="align-middle text-center" v-text="client.is_allowed_training_data_provision ? '○' : '☓'"></td>
              <td class="align-middle text-center" >
                <input type="checkbox" v-bind:value="client.id" v-model="deletedNotify" />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-end">
          <button class="btn btn-red" @click="deleteNotify">削除</button>
        </div>
      </div>
      
    </div>
    <footerComponent />
  </div>
</template>


<style lang="scss" scoped>

$bg_gray : #B1B0B0;

.container {
  min-height: 80vh;

  .title-btn {
    margin: 3rem 0;
    #title {
      margin: 0;
      img {
        width: 3rem;
        height: 3rem;
      }
      p {
        color: #333333;
      }
    }
  }

  .client-information {
    div {
      margin: 1rem 0;
      span {
        margin-left: 0.5rem;
        padding: 0.5rem;
        text-align: center;
        background-color: $bg_gray;
        color: #FFFBF9;
        border-radius: 5px;
      }
    }
  }

  .show-clients {
    margin-top: 1rem;
    .with-icon {
      &::placeholder{
        color: $bg_gray;
      }
      background-image: url("/img/25_search.svg");
      background-repeat: no-repeat;
      background-size: 1rem;
      background-position: right 0.5rem center;

      padding: 0.2rem 2rem 0.2rem 0.5rem;
      width: 40%;
      height: 2.5rem;
      margin-bottom: 1rem;
      border-radius: 5px;
      border-style: solid;
      border-color: $bg_gray;
    }
  }

  .sort-button {
    width: 1rem;
    height: 1rem;
  }
  .table-font-size {
    font-size: 0.8rem;
  }
  .col-no {
  width: 2.5%;
  }
  .col-name {
    width: 10%;
  }
  .col-category {
    width: 10%;
  }
  .col-administrator {
    width: 10%;
  }
  .col-email {
    width: 10%;
  }
  .col-status {
    width: 10%;
  }
  .col-plun {
    width: 10%;
  }
  .col-idNum {
    width: 5%;
  }
  .col-utilizationPeriod {
    width: 13%;
  }
  .col-bill {
    width: 7%;
  }
  .col-addContract {
    width: 5%;
  }
  .col-supplyData {
    width: 5%;
  }
  .col-delete {
    width: 2.5%;
  }
}
</style>


<script>
import { defineComponent } from "vue";
import menubar from "@/Pages/JVTA/menu_jvta.vue";
import footerComponent from "@/Pages/Components/footer.vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js";
import { Inertia } from '@inertiajs/inertia'
import { Link } from '@inertiajs/inertia-vue3'
import showLocalDate from "@/Pages/Components/showLocalDate.js";

export default defineComponent({
  components: { menubar, footerComponent, Link },
  data() {
    return {
      sort_key: "",
      search_word: "",
      sort_asc: 0,
      deletedNotify: [],
      clientSummary: [],
      filteredUsers: [],
    };
  },
  props: {
    clients: Array,
  },
  computed: {
    filterUsers() {
      let clients = this.clients;
      clients = clients.filter(client =>
        client.name.includes(this.search_word) || client.contractor_email.includes(this.search_word)
      );
      let processedClients = this.preprocessing(clients);
      
      return this.sort_users(processedClients);
    },
  }, 
  watch: {
    search_word: function() {
      this.filteredUsers = this.filterUsers;
    },
  },
  mounted(){
    this.InitialFilteredUsers(); // コンポーネントがマウントされたときに一度だけ実行
  },
  methods: {
    InitialFilteredUsers() {
      let clients = this.$props.clients;
      let processedClients = this.preprocessing(clients);
      let sortedClients = this.sort_users(processedClients);
      this.filteredUsers = sortedClients;
    },
    preprocessing(clients){
      this.clientSummary['contract_number'] = 0;
      this.clientSummary['use_contract_number'] = 0;
      this.clientSummary['id_number'] = 0;
      this.clientSummary['ai_model_number'] = 0;
      this.clientSummary['total_bill'] = 0;

      let use_contract_dates = 0;
      let total_bill_price = 0;
      // ソートのプログラムを適用するために、一次元のobjectに変換
      for (let [key,value] of Object.entries(clients)){
        value['user_length'] = value['users'].length;
        value['segment'] = this.contract_segment(value);
        value['bill'] = value['invoice_items'].filter(item => ! item.is_paid).map(item => item.unit_price * item.quantity).reduce((a,b) => a + b, 0);

        this.clientSummary['contract_number'] ++;
        this.clientSummary['use_contract_number']  += value['status'] == '0' ? 1 : 0;
        this.clientSummary['id_number'] += value['user_length'];
        this.clientSummary['ai_model_number'] += value['aimodels'].length;
        total_bill_price += value['bill'];

        //利用期間を集計
        use_contract_dates += Math.floor((new Date(value['client_contract_plan']['expiration_date']).getTime() -  new Date(value['client_contract_plan']['beginning_date']).getTime())/86400/1000 ) + 1;
      };

      // 合計金額を税込価格に変更
      total_bill_price *= 1.1
      this.clientSummary['total_bill'] = total_bill_price.toLocaleString('en-US')

      // 利用期間の平均を算出
      let use_contract_dates_average = Math.floor(use_contract_dates / clients.length);

      // 利用期間の平均を〇〇年〇〇ヶ月〇〇日に変更
      const elapsed_year = Math.floor(use_contract_dates_average / 365);
      use_contract_dates_average -= 365 * elapsed_year;
      const elapsed_month = Math.floor(use_contract_dates_average / 31);
      const elapsed_day = Math.floor(use_contract_dates_average - 31 * elapsed_month);
      this.clientSummary['usage_period'] = elapsed_year + '年' + elapsed_month + 'ヶ月' + elapsed_day +'日';

      return clients;
    },


    sortBy(key) {
      this.sort_key === key
        ? (this.sort_asc = (this.sort_asc+1)%3 )
        : (this.sort_asc = 1);
      if( this.sort_asc !== 0) {
        this.sort_key = key;
      }
      else{
        this.sort_key = "";
      }
      this.filteredUsers = this.sort_users(this.filteredUsers);
    },

    sort_users(clients) {
      if (this.sort_key != "") {
        let set = 1;
        this.sort_asc === 1
          ? (set = 1)
          : (set = -1);
        clients.sort((a, b) => {
          let a_value;
          let b_value;
          if (this.sort_key.includes(".")) {
            a_value = this.sort_key.split('.').reduce((acc, prop) => acc && acc[prop], a);
            b_value = this.sort_key.split('.').reduce((acc, prop) => acc && acc[prop], b);
          } else {
            a_value = a[this.sort_key];
            b_value = b[this.sort_key];
          }
          if (a_value < b_value) return -1 * set;
          if (a_value > b_value) return 1 * set;
          return 0;
        });
        return clients;
      } else {
        return clients;
      }
    },

    contract_segment: function(client) {
      return showLocalDate.showLocalDate(client['client_contract_plan']['beginning_date'], "-") + "～" + showLocalDate.showLocalDate(client['client_contract_plan']['expiration_date'], "-");
      // return this.japanese_date(client['client_contract_plan']['beginning_date'])+ "～" + this.japanese_date(client['client_contract_plan']['expiration_date']);
    },
    current_contract_plan: function(client) {
      let plans = client.client_contract_plans;
      return plans
        .filter(plan => new Date(plan.begging_date) > new Date())
        .sort((l_plan, r_plan) => new Date(l_plan.begging_date) < new Date(r_plan.begging_date))
        .at(0)
    },

    /*****************************************/
    // バックエンドが追記する関数（deleteNotify） */
    /*****************************************/
    // 追記内容
    // 1. データ削除をする命令を飛ばす
    //    削除対象のデータは this.deleteNotifyに格納しています．行目に記述されたコンソール出力を確認してください．
    // 2. ページリロードなどを行い，データの再取得（再レンダリング）を行う
    ///////////////////////////////////////////////////////////////////////////////////

    deleteNotify: function () {
      if (this.deletedNotify.length == 0) {
        alert('削除列の一つ以上のチェックボックスにチェックしてください');
        return;
      }
      if (!confirm('この操作はやり直せません')) {
        return;
      }

      this.deletedNotify.forEach(id => {
        Inertia.delete(route('clients.destroy', id));
      });

      alert('選択されたクライアントを削除しました');
      Inertia.reload();

      return;
    },
},
});
</script>